import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {UserSubscription, UserSubscriptionCategory, UserSubscriptionType} from "../../../user/user-subscription";
import {User} from "../../../user/user";
import {first, switchMap, takeUntil} from "rxjs/operators";
import {Store} from "@ngrx/store";
import {combineLatest, Subscription} from "rxjs";
import * as fromStore from '../../../store';
import {Subject} from "rxjs";
import {UserSubscriptionStatus} from "../../../user/user-subscription-status";


@Component({
    selector: 'db-cdn-info',
    templateUrl: './db-cdn-info.component.html',
    styleUrls: ['./db-cdn-info.component.scss'],
    standalone: false
})
export class DbCdnInfoComponent implements OnInit, OnDestroy {

  public userSubscription: UserSubscription;
  public user: User;
  public UserSubscriptionCategory: any = UserSubscriptionCategory;
  public UserSubscriptionType: any = UserSubscriptionType;
  private subscriptions: Subscription[]
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  @Input() userSubscriptionStorage: number;
  @Input() userSubscriptionVisits: number;
  @Input() userSubscriptionStatus: any = UserSubscriptionStatus;

  constructor(
    private _store: Store<fromStore.DbStoreState>,
  ) {}

  ngOnInit() {
    this.addEventHandlers();
  }

  private addEventHandlers(): void {
    this.subscriptions = [];

    this.subscriptions.push(
      this._store.select(fromStore.getUserLoaded)
        .pipe(
          first((loaded: boolean) => loaded),
          switchMap(() => combineLatest(
              this._store.select(fromStore.getUser),
              this._store.select(fromStore.getUserSubscription)
            )
          ),
          takeUntil(this._destroyStream$)
        )
        .subscribe(([user, userSubscription]) => {
          this.user = user;
          this.userSubscription = userSubscription;
        })
    );
  }

  ngOnDestroy(): void {
    this.removeEventHandlers();
  }

  private removeEventHandlers(): void {
    this.subscriptions.forEach((subscription: Subscription): void => {
      subscription.unsubscribe();
    });
    this.subscriptions = null;
  }

}
